export default __webpack_public_path__ + "static/media/WalletBlack.633c8c19.svg";